export const INITIAL_STATE = "INITIAL_STATE";
export const CHANGE_PHONE_NUMBER = "CHANGE_PHONE_NUMBER";
export const CHANGE_OTP = "CHANGE_OTP";
export const CHANGE_NAME = "CHANGE_NAME";
export const CHANGE_EMAIL = "CHANGE_EMAIL";
export const CHANGE_DOB = "CHANGE_DOB";
export const CHANGE_NIK = "CHANGE_NIK";
export const CHANGE_PASSWORD = "CHANGE_PASSWORD";
export const CHANGE_CONFIRM = "CHANGE_CONFIRM";
export const CHANGE_SHOW_PASSWORD = "CHANGE_SHOW_PASSWORD";
export const CHANGE_SHOW_CONFIRM = "CHANGE_SHOW_CONFIRM";
export const SUBMIT_PHONE_NUMBER = "SUBMIT_PHONE_NUMBER";
export const SUBMIT_OTP = "SUBMIT_OTP";
export const SUBMIT_INFO = "SUBMIT_INFO";
export const SUBMIT_PASSWORD = "SUBMIT_PASSWORD";
export const ERROR_PHONE_NUMBER = "ERROR_PHONE_NUMBER";
export const ERROR_OTP = "ERROR_OTP";
export const ERROR_NAME = "ERROR_NAME";
export const ERROR_EMAIL = "ERROR_EMAIL";
export const ERROR_DOB = "ERROR_DOB";
export const ERROR_NIK = "ERROR_NIK";
export const ERROR_PASSWORD = "ERROR_PASSWORD";
export const ERROR_CONFIRM_PASSWORD = "ERROR_CONFIRM_PASSWORD";
export const CHANGE_OTP_SUCCESS = "CHANGE_OTP_SUCCESS";
export const RESEND_OTP = "RESEND_OTP";
export const SUBMIT_ONPROGRESS = "SUBMIT_ONPROGRESS";
export const SUBMIT_BACK = "SUBMIT_BACK";